import { render, staticRenderFns } from "./feeDetailRuleBill.vue?vue&type=template&id=383c1c54"
import script from "./feeDetailRuleBill.vue?vue&type=script&lang=js"
export * from "./feeDetailRuleBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports